/**
 * stallRecorder.js — a diagnostic, not a feature (2026-09-23).
 *
 * Matt reported the page hanging ("Page Unresponsive") and typing stutter while the meeting-notes
 * import was open, and it could not be reproduced in a fresh tab. Rather than guess at a cause,
 * this records every main-thread stall over STALL_MS using Chrome's Long Animation Frames API,
 * which attributes the frame to the scripts that ran in it (invoker, function, source file).
 *
 * Read it from the affected tab's console (or through Claude in Chrome):
 *   window.__ajStalls            // newest last
 *   JSON.parse(sessionStorage.getItem('aj-stalls'))   // survives a reload of that tab
 * Each entry: { at, ms, blockingMs, where, scripts: [{ invoker, fn, src, ms }] }.
 *
 * Idempotent (starting twice is a no-op), silent where the API is unsupported, capped at 40
 * entries. Delete this file and its one import once the cause is found.
 */

const STALL_MS = 300
const MAX = 40
let started = false

export function startStallRecorder(where) {
  if (typeof window !== 'undefined') window.__ajStallWhere = where || window.__ajStallWhere || ''
  if (started || typeof PerformanceObserver === 'undefined') return
  const types = PerformanceObserver.supportedEntryTypes || []
  if (!types.includes('long-animation-frame')) return
  started = true
  let saved = []
  try { saved = JSON.parse(sessionStorage.getItem('aj-stalls') || '[]') || [] } catch (_) { saved = [] }
  window.__ajStalls = saved
  try {
    new PerformanceObserver(list => {
      for (const e of list.getEntries()) {
        if (e.duration < STALL_MS) continue
        const scripts = (e.scripts || [])
          .slice().sort((a, b) => b.duration - a.duration).slice(0, 5)
          .map(s => ({ invoker: s.invoker, fn: s.sourceFunctionName || '', src: String(s.sourceURL || '').split('/').pop(), ms: Math.round(s.duration) }))
        window.__ajStalls.push({
          at: new Date().toISOString(), ms: Math.round(e.duration), blockingMs: Math.round(e.blockingDuration || 0),
          where: window.__ajStallWhere || '', scripts,
        })
        if (window.__ajStalls.length > MAX) window.__ajStalls.splice(0, window.__ajStalls.length - MAX)
        try { sessionStorage.setItem('aj-stalls', JSON.stringify(window.__ajStalls)) } catch (_) { /* full or blocked */ }
      }
    }).observe({ type: 'long-animation-frame', buffered: true })
  } catch (_) { /* unsupported */ }
}
